// eslint-disable-next-line max-len

export default [
  {
    label: 'Niue Time',
    value: 'Pacific/Niue',
    offset: -11
  },
  {
    label: 'Samoa Standard Time',
    value: 'Pacific/Pago_Pago',
    offset: -11
  },
  {
    label: 'Cook Islands Standard Time',
    value: 'Pacific/Rarotonga',
    offset: -10
  },
  {
    label: 'Hawaii-Aleutian Standard Time',
    value: 'Pacific/Honolulu',
    offset: -10
  },
  {
    label: 'Hawaii-Aleutian Time',
    value: 'America/Adak',
    offset: -10
  },
  {
    label: 'Tahiti Time',
    value: 'Pacific/Tahiti',
    offset: -10
  },
  {
    label: 'Marquesas Time',
    value: 'Pacific/Marquesas',
    offset: -9.5
  },
  {
    label: 'Alaska Time - Anchorage',
    value: 'America/Anchorage',
    offset: -9
  },
  {
    label: 'Alaska Time - Juneau',
    value: 'America/Juneau',
    offset: -9
  },
  {
    label: 'Alaska Time - Nome',
    value: 'America/Nome',
    offset: -9
  },
  {
    label: 'Alaska Time - Sitka',
    value: 'America/Sitka',
    offset: -9
  },
  {
    label: 'Alaska Time - Yakutat',
    value: 'America/Yakutat',
    offset: -9
  },
  {
    label: 'Gambier Time',
    value: 'Pacific/Gambier',
    offset: -9
  },
  {
    label: 'Pacific Time - Dawson',
    value: 'America/Dawson',
    offset: -8
  },
  {
    label: 'Pacific Time - Los Angeles',
    value: 'America/Los_Angeles',
    offset: -8
  },
  {
    label: 'Pacific Time - Metlakatla',
    value: 'America/Metlakatla',
    offset: -8
  },
  {
    label: 'Pacific Time - Tijuana',
    value: 'America/Tijuana',
    offset: -8
  },
  {
    label: 'Pacific Time - Vancouver',
    value: 'America/Vancouver',
    offset: -8
  },
  {
    label: 'Pacific Time - Whitehorse',
    value: 'America/Whitehorse',
    offset: -8
  },
  {
    label: 'Pitcairn Time',
    value: 'Pacific/Pitcairn',
    offset: -8
  },
  {
    label: 'Mexican Pacific Standard Time',
    value: 'America/Hermosillo',
    offset: -7
  },
  {
    label: 'Mexican Pacific Time - Chihuahua',
    value: 'America/Chihuahua',
    offset: -7
  },
  {
    label: 'Mexican Pacific Time - Mazatlan',
    value: 'America/Mazatlan',
    offset: -7
  },
  {
    label: 'Mountain Standard Time - Creston',
    value: 'America/Creston',
    offset: -7
  },
  {
    label: 'Mountain Standard Time - Dawson Creek',
    value: 'America/Dawson_Creek',
    offset: -7
  },
  {
    label: 'Mountain Standard Time - Fort Nelson',
    value: 'America/Fort_Nelson',
    offset: -7
  },
  {
    label: 'Mountain Standard Time - Phoenix',
    value: 'America/Phoenix',
    offset: -7
  },
  {
    label: 'Mountain Time - Boise',
    value: 'America/Boise',
    offset: -7
  },
  {
    label: 'Mountain Time - Cambridge Bay',
    value: 'America/Cambridge_Bay',
    offset: -7
  },
  {
    label: 'Mountain Time - Denver',
    value: 'America/Denver',
    offset: -7
  },
  {
    label: 'Mountain Time - Edmonton',
    value: 'America/Edmonton',
    offset: -7
  },
  {
    label: 'Mountain Time - Inuvik',
    value: 'America/Inuvik',
    offset: -7
  },
  {
    label: 'Mountain Time - Ojinaga',
    value: 'America/Ojinaga',
    offset: -7
  },
  {
    label: 'Mountain Time - Yellowknife',
    value: 'America/Yellowknife',
    offset: -7
  },
  {
    label: 'Central Standard Time - Belize',
    value: 'America/Belize',
    offset: -6
  },
  {
    label: 'Central Standard Time - Costa Rica',
    value: 'America/Costa_Rica',
    offset: -6
  },
  {
    label: 'Central Standard Time - El Salvador',
    value: 'America/El_Salvador',
    offset: -6
  },
  {
    label: 'Central Standard Time - Guatemala',
    value: 'America/Guatemala',
    offset: -6
  },
  {
    label: 'Central Standard Time - Managua',
    value: 'America/Managua',
    offset: -6
  },
  {
    label: 'Central Standard Time - Regina',
    value: 'America/Regina',
    offset: -6
  },
  {
    label: 'Central Standard Time - Swift Current',
    value: 'America/Swift_Current',
    offset: -6
  },
  {
    label: 'Central Standard Time - Tegucigalpa',
    value: 'America/Tegucigalpa',
    offset: -6
  },
  {
    label: 'Central Time - Bahia Banderas',
    value: 'America/Bahia_Banderas',
    offset: -6
  },
  {
    label: 'Central Time - Beulah, North Dakota',
    value: 'America/North_Dakota/Beulah',
    offset: -6
  },
  {
    label: 'Central Time - Center, North Dakota',
    value: 'America/North_Dakota/Center',
    offset: -6
  },
  {
    label: 'Central Time - Chicago',
    value: 'America/Chicago',
    offset: -6
  },
  {
    label: 'Central Time - Knox, Indiana',
    value: 'America/Indiana/Knox',
    offset: -6
  },
  {
    label: 'Central Time - Matamoros',
    value: 'America/Matamoros',
    offset: -6
  },
  {
    label: 'Central Time - Menominee',
    value: 'America/Menominee',
    offset: -6
  },
  {
    label: 'Central Time - Merida',
    value: 'America/Merida',
    offset: -6
  },
  {
    label: 'Central Time - Mexico City',
    value: 'America/Mexico_City',
    offset: -6
  },
  {
    label: 'Central Time - Monterrey',
    value: 'America/Monterrey',
    offset: -6
  },
  {
    label: 'Central Time - New Salem, North Dakota',
    value: 'America/North_Dakota/New_Salem',
    offset: -6
  },
  {
    label: 'Central Time - Rainy River',
    value: 'America/Rainy_River',
    offset: -6
  },
  {
    label: 'Central Time - Rankin Inlet',
    value: 'America/Rankin_Inlet',
    offset: -6
  },
  {
    label: 'Central Time - Resolute',
    value: 'America/Resolute',
    offset: -6
  },
  {
    label: 'Central Time - Tell City, Indiana',
    value: 'America/Indiana/Tell_City',
    offset: -6
  },
  {
    label: 'Central Time - Winnipeg',
    value: 'America/Winnipeg',
    offset: -6
  },
  {
    label: 'Galapagos Time',
    value: 'Pacific/Galapagos',
    offset: -6
  },
  {
    label: 'Acre Standard Time - Eirunepe',
    value: 'America/Eirunepe',
    offset: -5
  },
  {
    label: 'Acre Standard Time - Rio Branco',
    value: 'America/Rio_Branco',
    offset: -5
  },
  {
    label: 'Colombia Standard Time',
    value: 'America/Bogota',
    offset: -5
  },
  {
    label: 'Cuba Time',
    value: 'America/Havana',
    offset: -5
  },
  {
    label: 'Easter Island Time',
    value: 'Pacific/Easter',
    offset: -5
  },
  {
    label: 'Eastern Standard Time - Atikokan',
    value: 'America/Atikokan',
    offset: -5
  },
  {
    label: 'Eastern Standard Time - Cancun',
    value: 'America/Cancun',
    offset: -5
  },
  {
    label: 'Eastern Standard Time - Jamaica',
    value: 'America/Jamaica',
    offset: -5
  },
  {
    label: 'Eastern Standard Time - Panama',
    value: 'America/Panama',
    offset: -5
  },
  {
    label: 'Eastern Time - Detroit',
    value: 'America/Detroit',
    offset: -5
  },
  {
    label: 'Eastern Time - Grand Turk',
    value: 'America/Grand_Turk',
    offset: -5
  },
  {
    label: 'Eastern Time - Indianapolis',
    value: 'America/Indiana/Indianapolis',
    offset: -5
  },
  {
    label: 'Eastern Time - Iqaluit',
    value: 'America/Iqaluit',
    offset: -5
  },
  {
    label: 'Eastern Time - Louisville',
    value: 'America/Kentucky/Louisville',
    offset: -5
  },
  {
    label: 'Eastern Time - Marengo, Indiana',
    value: 'America/Indiana/Marengo',
    offset: -5
  },
  {
    label: 'Eastern Time - Monticello, Kentucky',
    value: 'America/Kentucky/Monticello',
    offset: -5
  },
  {
    label: 'Eastern Time - Nassau',
    value: 'America/Nassau',
    offset: -5
  },
  {
    label: 'Eastern Time - New York',
    value: 'America/New_York',
    offset: -5
  },
  {
    label: 'Eastern Time - Nipigon',
    value: 'America/Nipigon',
    offset: -5
  },
  {
    label: 'Eastern Time - Pangnirtung',
    value: 'America/Pangnirtung',
    offset: -5
  },
  {
    label: 'Eastern Time - Petersburg, Indiana',
    value: 'America/Indiana/Petersburg',
    offset: -5
  },
  {
    label: 'Eastern Time - Port-au-Prince',
    value: 'America/Port-au-Prince',
    offset: -5
  },
  {
    label: 'Eastern Time - Thunder Bay',
    value: 'America/Thunder_Bay',
    offset: -5
  },
  {
    label: 'Eastern Time - Toronto',
    value: 'America/Toronto',
    offset: -5
  },
  {
    label: 'Eastern Time - Vevay, Indiana',
    value: 'America/Indiana/Vevay',
    offset: -5
  },
  {
    label: 'Eastern Time - Vincennes, Indiana',
    value: 'America/Indiana/Vincennes',
    offset: -5
  },
  {
    label: 'Eastern Time - Winamac, Indiana',
    value: 'America/Indiana/Winamac',
    offset: -5
  },
  {
    label: 'Ecuador Time',
    value: 'America/Guayaquil',
    offset: -5
  },
  {
    label: 'Peru Standard Time',
    value: 'America/Lima',
    offset: -5
  },
  {
    label: 'Amazon Standard Time - Boa Vista',
    value: 'America/Boa_Vista',
    offset: -4
  },
  {
    label: 'Amazon Standard Time - Manaus',
    value: 'America/Manaus',
    offset: -4
  },
  {
    label: 'Amazon Standard Time - Porto Velho',
    value: 'America/Porto_Velho',
    offset: -4
  },
  {
    label: 'Atlantic Standard Time - Barbados',
    value: 'America/Barbados',
    offset: -4
  },
  {
    label: 'Atlantic Standard Time - Blanc-Sablon',
    value: 'America/Blanc-Sablon',
    offset: -4
  },
  {
    label: 'Atlantic Standard Time - Curaçao',
    value: 'America/Curacao',
    offset: -4
  },
  {
    label: 'Atlantic Standard Time - Martinique',
    value: 'America/Martinique',
    offset: -4
  },
  {
    label: 'Atlantic Standard Time - Port of Spain',
    value: 'America/Port_of_Spain',
    offset: -4
  },
  {
    label: 'Atlantic Standard Time - Puerto Rico',
    value: 'America/Puerto_Rico',
    offset: -4
  },
  {
    label: 'Atlantic Standard Time - Santo Domingo',
    value: 'America/Santo_Domingo',
    offset: -4
  },
  {
    label: 'Atlantic Time - Bermuda',
    value: 'Atlantic/Bermuda',
    offset: -4
  },
  {
    label: 'Atlantic Time - Glace Bay',
    value: 'America/Glace_Bay',
    offset: -4
  },
  {
    label: 'Atlantic Time - Goose Bay',
    value: 'America/Goose_Bay',
    offset: -4
  },
  {
    label: 'Atlantic Time - Halifax',
    value: 'America/Halifax',
    offset: -4
  },
  {
    label: 'Atlantic Time - Moncton',
    value: 'America/Moncton',
    offset: -4
  },
  {
    label: 'Atlantic Time - Thule',
    value: 'America/Thule',
    offset: -4
  },
  {
    label: 'Bolivia Time',
    value: 'America/La_Paz',
    offset: -4
  },
  {
    label: 'Guyana Time',
    value: 'America/Guyana',
    offset: -4
  },
  {
    label: 'Venezuela Time',
    value: 'America/Caracas',
    offset: -4
  },
  {
    label: 'Newfoundland Time',
    value: 'America/St_Johns',
    offset: -3.5
  },
  {
    label: 'Amazon Time (Campo Grande)',
    value: 'America/Campo_Grande',
    offset: -3
  },
  {
    label: 'Amazon Time (Cuiaba)',
    value: 'America/Cuiaba',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Buenos Aires',
    value: 'America/Argentina/Buenos_Aires',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Catamarca',
    value: 'America/Argentina/Catamarca',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Cordoba',
    value: 'America/Argentina/Cordoba',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Jujuy',
    value: 'America/Argentina/Jujuy',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - La Rioja',
    value: 'America/Argentina/La_Rioja',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Mendoza',
    value: 'America/Argentina/Mendoza',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Rio Gallegos',
    value: 'America/Argentina/Rio_Gallegos',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Salta',
    value: 'America/Argentina/Salta',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - San Juan',
    value: 'America/Argentina/San_Juan',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Tucuman',
    value: 'America/Argentina/Tucuman',
    offset: -3
  },
  {
    label: 'Argentina Standard Time - Ushuaia',
    value: 'America/Argentina/Ushuaia',
    offset: -3
  },
  {
    label: 'Brasilia Standard Time - Araguaina',
    value: 'America/Araguaina',
    offset: -3
  },
  {
    label: 'Brasilia Standard Time - Bahia',
    value: 'America/Bahia',
    offset: -3
  },
  {
    label: 'Brasilia Standard Time - Belem',
    value: 'America/Belem',
    offset: -3
  },
  {
    label: 'Brasilia Standard Time - Fortaleza',
    value: 'America/Fortaleza',
    offset: -3
  },
  {
    label: 'Brasilia Standard Time - Maceio',
    value: 'America/Maceio',
    offset: -3
  },
  {
    label: 'Brasilia Standard Time - Recife',
    value: 'America/Recife',
    offset: -3
  },
  {
    label: 'Brasilia Standard Time - Santarem',
    value: 'America/Santarem',
    offset: -3
  },
  {
    label: 'Chile Time',
    value: 'America/Santiago',
    offset: -3
  },
  {
    label: 'Falkland Islands Standard Time',
    value: 'Atlantic/Stanley',
    offset: -3
  },
  {
    label: 'French Guiana Time',
    value: 'America/Cayenne',
    offset: -3
  },
  {
    label: 'Palmer Time',
    value: 'Antarctica/Palmer',
    offset: -3
  },
  {
    label: 'Paraguay Time',
    value: 'America/Asuncion',
    offset: -3
  },
  {
    label: 'Punta Arenas Time',
    value: 'America/Punta_Arenas',
    offset: -3
  },
  {
    label: 'Rothera Time',
    value: 'Antarctica/Rothera',
    offset: -3
  },
  {
    label: 'St Pierre & Miquelon Time',
    value: 'America/Miquelon',
    offset: -3
  },
  {
    label: 'Suriname Time',
    value: 'America/Paramaribo',
    offset: -3
  },
  {
    label: 'Uruguay Standard Time',
    value: 'America/Montevideo',
    offset: -3
  },
  {
    label: 'West Greenland Time',
    value: 'America/Godthab',
    offset: -3
  },
  {
    label: 'Western Argentina Standard Time',
    value: 'America/Argentina/San_Luis',
    offset: -3
  },
  {
    label: 'Brasilia Time',
    value: 'America/Sao_Paulo',
    offset: -2
  },
  {
    label: 'Fernando de Noronha Standard Time',
    value: 'America/Noronha',
    offset: -2
  },
  {
    label: 'South Georgia Time',
    value: 'Atlantic/South_Georgia',
    offset: -2
  },
  {
    label: 'Azores Time',
    value: 'Atlantic/Azores',
    offset: -1
  },
  {
    label: 'Cape Verde Standard Time',
    value: 'Atlantic/Cape_Verde',
    offset: -1
  },
  {
    label: 'East Greenland Time',
    value: 'America/Scoresbysund',
    offset: -1
  },
  {
    label: 'Coordinated Universal Time',
    value: 'UTC',
    offset: 0
  },
  {
    label: 'Greenwich Mean Time',
    value: 'GMT',
    offset: 0
  },
  {
    label: 'Greenwich Mean Time - Abidjan',
    value: 'Africa/Abidjan',
    offset: 0
  },
  {
    label: 'Greenwich Mean Time - Accra',
    value: 'Africa/Accra',
    offset: 0
  },
  {
    label: 'Greenwich Mean Time - Bissau',
    value: 'Africa/Bissau',
    offset: 0
  },
  {
    label: 'Greenwich Mean Time - Danmarkshavn',
    value: 'America/Danmarkshavn',
    offset: 0
  },
  {
    label: 'Greenwich Mean Time - Monrovia',
    value: 'Africa/Monrovia',
    offset: 0
  },
  {
    label: 'Greenwich Mean Time - Reykjavik',
    value: 'Atlantic/Reykjavik',
    offset: 0
  },
  {
    label: 'Greenwich Mean Time - São Tomé',
    value: 'Africa/Sao_Tome',
    offset: 0
  },
  {
    label: 'Ireland Time',
    value: 'Europe/Dublin',
    offset: 0
  },
  {
    label: 'Troll Time',
    value: 'Antarctica/Troll',
    offset: 0
  },
  {
    label: 'United Kingdom Time',
    value: 'Europe/London',
    offset: 0
  },
  {
    label: 'Western European Time - Canary',
    value: 'Atlantic/Canary',
    offset: 0
  },
  {
    label: 'Western European Time - Faroe',
    value: 'Atlantic/Faroe',
    offset: 0
  },
  {
    label: 'Western European Time - Lisbon',
    value: 'Europe/Lisbon',
    offset: 0
  },
  {
    label: 'Western European Time - Madeira',
    value: 'Atlantic/Madeira',
    offset: 0
  },
  {
    label: 'Central European Standard Time - Algiers',
    value: 'Africa/Algiers',
    offset: 1
  },
  {
    label: 'Central European Standard Time - Tunis',
    value: 'Africa/Tunis',
    offset: 1
  },
  {
    label: 'Central European Time - Amsterdam',
    value: 'Europe/Amsterdam',
    offset: 1
  },
  {
    label: 'Central European Time - Andorra',
    value: 'Europe/Andorra',
    offset: 1
  },
  {
    label: 'Central European Time - Belgrade',
    value: 'Europe/Belgrade',
    offset: 1
  },
  {
    label: 'Central European Time - Berlin',
    value: 'Europe/Berlin',
    offset: 1
  },
  {
    label: 'Central European Time - Brussels',
    value: 'Europe/Brussels',
    offset: 1
  },
  {
    label: 'Central European Time - Budapest',
    value: 'Europe/Budapest',
    offset: 1
  },
  {
    label: 'Central European Time - Ceuta',
    value: 'Africa/Ceuta',
    offset: 1
  },
  {
    label: 'Central European Time - Copenhagen',
    value: 'Europe/Copenhagen',
    offset: 1
  },
  {
    label: 'Central European Time - Gibraltar',
    value: 'Europe/Gibraltar',
    offset: 1
  },
  {
    label: 'Central European Time - Luxembourg',
    value: 'Europe/Luxembourg',
    offset: 1
  },
  {
    label: 'Central European Time - Madrid',
    value: 'Europe/Madrid',
    offset: 1
  },
  {
    label: 'Central European Time - Malta',
    value: 'Europe/Malta',
    offset: 1
  },
  {
    label: 'Central European Time - Monaco',
    value: 'Europe/Monaco',
    offset: 1
  },
  {
    label: 'Central European Time - Oslo',
    value: 'Europe/Oslo',
    offset: 1
  },
  {
    label: 'Central European Time - Paris',
    value: 'Europe/Paris',
    offset: 1
  },
  {
    label: 'Central European Time - Prague',
    value: 'Europe/Prague',
    offset: 1
  },
  {
    label: 'Central European Time - Rome',
    value: 'Europe/Rome',
    offset: 1
  },
  {
    label: 'Central European Time - Stockholm',
    value: 'Europe/Stockholm',
    offset: 1
  },
  {
    label: 'Central European Time - Tirane',
    value: 'Europe/Tirane',
    offset: 1
  },
  {
    label: 'Central European Time - Vienna',
    value: 'Europe/Vienna',
    offset: 1
  },
  {
    label: 'Central European Time - Warsaw',
    value: 'Europe/Warsaw',
    offset: 1
  },
  {
    label: 'Central European Time - Zurich',
    value: 'Europe/Zurich',
    offset: 1
  },
  {
    label: 'Morocco Time',
    value: 'Africa/Casablanca',
    offset: 1
  },
  {
    label: 'West Africa Standard Time - Lagos',
    value: 'Africa/Lagos',
    offset: 1
  },
  {
    label: 'West Africa Standard Time - Ndjamena',
    value: 'Africa/Ndjamena',
    offset: 1
  },
  {
    label: 'Western Sahara Time',
    value: 'Africa/El_Aaiun',
    offset: 1
  },
  {
    label: 'Central Africa Time - Khartoum',
    value: 'Africa/Khartoum',
    offset: 2
  },
  {
    label: 'Central Africa Time - Maputo',
    value: 'Africa/Maputo',
    offset: 2
  },
  {
    label: 'Central Africa Time - Windhoek',
    value: 'Africa/Windhoek',
    offset: 2
  },
  {
    label: 'Eastern European Standard Time - Cairo',
    value: 'Africa/Cairo',
    offset: 2
  },
  {
    label: 'Eastern European Standard Time - Kaliningrad',
    value: 'Europe/Kaliningrad',
    offset: 2
  },
  {
    label: 'Eastern European Standard Time - Tripoli',
    value: 'Africa/Tripoli',
    offset: 2
  },
  {
    label: 'Eastern European Time - Amman',
    value: 'Asia/Amman',
    offset: 2
  },
  {
    label: 'Eastern European Time - Athens',
    value: 'Europe/Athens',
    offset: 2
  },
  {
    label: 'Eastern European Time - Beirut',
    value: 'Asia/Beirut',
    offset: 2
  },
  {
    label: 'Eastern European Time - Bucharest',
    value: 'Europe/Bucharest',
    offset: 2
  },
  {
    label: 'Eastern European Time - Chisinau',
    value: 'Europe/Chisinau',
    offset: 2
  },
  {
    label: 'Eastern European Time - Damascus',
    value: 'Asia/Damascus',
    offset: 2
  },
  {
    label: 'Eastern European Time - Gaza',
    value: 'Asia/Gaza',
    offset: 2
  },
  {
    label: 'Eastern European Time - Hebron',
    value: 'Asia/Hebron',
    offset: 2
  },
  {
    label: 'Eastern European Time - Helsinki',
    value: 'Europe/Helsinki',
    offset: 2
  },
  {
    label: 'Eastern European Time - Kiev',
    value: 'Europe/Kiev',
    offset: 2
  },
  {
    label: 'Eastern European Time - Nicosia',
    value: 'Asia/Nicosia',
    offset: 2
  },
  {
    label: 'Eastern European Time - Riga',
    value: 'Europe/Riga',
    offset: 2
  },
  {
    label: 'Eastern European Time - Sofia',
    value: 'Europe/Sofia',
    offset: 2
  },
  {
    label: 'Eastern European Time - Tallinn',
    value: 'Europe/Tallinn',
    offset: 2
  },
  {
    label: 'Eastern European Time - Uzhhorod',
    value: 'Europe/Uzhgorod',
    offset: 2
  },
  {
    label: 'Eastern European Time - Vilnius',
    value: 'Europe/Vilnius',
    offset: 2
  },
  {
    label: 'Eastern European Time - Zaporozhye',
    value: 'Europe/Zaporozhye',
    offset: 2
  },
  {
    label: 'Famagusta Time',
    value: 'Asia/Famagusta',
    offset: 2
  },
  {
    label: 'Israel Time',
    value: 'Asia/Jerusalem',
    offset: 2
  },
  {
    label: 'South Africa Standard Time',
    value: 'Africa/Johannesburg',
    offset: 2
  },
  {
    label: 'Arabian Standard Time - Baghdad',
    value: 'Asia/Baghdad',
    offset: 3
  },
  {
    label: 'Arabian Standard Time - Qatar',
    value: 'Asia/Qatar',
    offset: 3
  },
  {
    label: 'Arabian Standard Time - Riyadh',
    value: 'Asia/Riyadh',
    offset: 3
  },
  {
    label: 'East Africa Time - Juba',
    value: 'Africa/Juba',
    offset: 3
  },
  {
    label: 'East Africa Time - Nairobi',
    value: 'Africa/Nairobi',
    offset: 3
  },
  {
    label: 'Kirov Time',
    value: 'Europe/Kirov',
    offset: 3
  },
  {
    label: 'Moscow Standard Time - Minsk',
    value: 'Europe/Minsk',
    offset: 3
  },
  {
    label: 'Moscow Standard Time - Moscow',
    value: 'Europe/Moscow',
    offset: 3
  },
  {
    label: 'Moscow Standard Time - Simferopol',
    value: 'Europe/Simferopol',
    offset: 3
  },
  {
    label: 'Syowa Time',
    value: 'Antarctica/Syowa',
    offset: 3
  },
  {
    label: 'Turkey Time',
    value: 'Europe/Istanbul',
    offset: 3
  },
  {
    label: 'Iran Time',
    value: 'Asia/Tehran',
    offset: 3.5
  },
  {
    label: 'Armenia Standard Time',
    value: 'Asia/Yerevan',
    offset: 4
  },
  {
    label: 'Astrakhan Time',
    value: 'Europe/Astrakhan',
    offset: 4
  },
  {
    label: 'Azerbaijan Standard Time',
    value: 'Asia/Baku',
    offset: 4
  },
  {
    label: 'Georgia Standard Time',
    value: 'Asia/Tbilisi',
    offset: 4
  },
  {
    label: 'Gulf Standard Time',
    value: 'Asia/Dubai',
    offset: 4
  },
  {
    label: 'Mauritius Standard Time',
    value: 'Indian/Mauritius',
    offset: 4
  },
  {
    label: 'Réunion Time',
    value: 'Indian/Reunion',
    offset: 4
  },
  {
    label: 'Samara Standard Time',
    value: 'Europe/Samara',
    offset: 4
  },
  {
    label: 'Saratov Time',
    value: 'Europe/Saratov',
    offset: 4
  },
  {
    label: 'Seychelles Time',
    value: 'Indian/Mahe',
    offset: 4
  },
  {
    label: 'Ulyanovsk Time',
    value: 'Europe/Ulyanovsk',
    offset: 4
  },
  {
    label: 'Volgograd Standard Time',
    value: 'Europe/Volgograd',
    offset: 4
  },
  {
    label: 'Afghanistan Time',
    value: 'Asia/Kabul',
    offset: 4.5
  },
  {
    label: 'French Southern & Antarctic Time',
    value: 'Indian/Kerguelen',
    offset: 5
  },
  {
    label: 'Maldives Time',
    value: 'Indian/Maldives',
    offset: 5
  },
  {
    label: 'Mawson Time',
    value: 'Antarctica/Mawson',
    offset: 5
  },
  {
    label: 'Pakistan Standard Time',
    value: 'Asia/Karachi',
    offset: 5
  },
  {
    label: 'Tajikistan Time',
    value: 'Asia/Dushanbe',
    offset: 5
  },
  {
    label: 'Turkmenistan Standard Time',
    value: 'Asia/Ashgabat',
    offset: 5
  },
  {
    label: 'Uzbekistan Standard Time - Samarkand',
    value: 'Asia/Samarkand',
    offset: 5
  },
  {
    label: 'Uzbekistan Standard Time - Tashkent',
    value: 'Asia/Tashkent',
    offset: 5
  },
  {
    label: 'West Kazakhstan Time - Aqtau',
    value: 'Asia/Aqtau',
    offset: 5
  },
  {
    label: 'West Kazakhstan Time - Aqtobe',
    value: 'Asia/Aqtobe',
    offset: 5
  },
  {
    label: 'West Kazakhstan Time - Atyrau',
    value: 'Asia/Atyrau',
    offset: 5
  },
  {
    label: 'West Kazakhstan Time - Oral',
    value: 'Asia/Oral',
    offset: 5
  },
  {
    label: 'West Kazakhstan Time - Qyzylorda',
    value: 'Asia/Qyzylorda',
    offset: 5
  },
  {
    label: 'Yekaterinburg Standard Time',
    value: 'Asia/Yekaterinburg',
    offset: 5
  },
  {
    label: 'India Standard Time - Colombo',
    value: 'Asia/Colombo',
    offset: 5.5
  },
  {
    label: 'India Standard Time - Kolkata',
    value: 'Asia/Kolkata',
    offset: 5.5
  },
  {
    label: 'Nepal Time',
    value: 'Asia/Kathmandu',
    offset: 5.75
  },
  {
    label: 'Bangladesh Standard Time',
    value: 'Asia/Dhaka',
    offset: 6
  },
  {
    label: 'Bhutan Time',
    value: 'Asia/Thimphu',
    offset: 6
  },
  {
    label: 'East Kazakhstan Time - Almaty',
    value: 'Asia/Almaty',
    offset: 6
  },
  {
    label: 'Indian Ocean Time',
    value: 'Indian/Chagos',
    offset: 6
  },
  {
    label: 'Kyrgyzstan Time',
    value: 'Asia/Bishkek',
    offset: 6
  },
  {
    label: 'Omsk Standard Time',
    value: 'Asia/Omsk',
    offset: 6
  },
  {
    label: 'Urumqi Time',
    value: 'Asia/Urumqi',
    offset: 6
  },
  {
    label: 'Vostok Time',
    value: 'Antarctica/Vostok',
    offset: 6
  },
  {
    label: 'Cocos Islands Time',
    value: 'Indian/Cocos',
    offset: 6.5
  },
  {
    label: 'Myanmar Time',
    value: 'Asia/Yangon',
    offset: 6.5
  },
  {
    label: 'Barnaul Time',
    value: 'Asia/Barnaul',
    offset: 7
  },
  {
    label: 'Christmas Island Time',
    value: 'Indian/Christmas',
    offset: 7
  },
  {
    label: 'Davis Time',
    value: 'Antarctica/Davis',
    offset: 7
  },
  {
    label: 'Hovd Standard Time',
    value: 'Asia/Hovd',
    offset: 7
  },
  {
    label: 'Indochina Time - Bangkok',
    value: 'Asia/Bangkok',
    offset: 7
  },
  {
    label: 'Indochina Time - Ho Chi Minh City',
    value: 'Asia/Ho_Chi_Minh',
    offset: 7
  },
  {
    label: 'Krasnoyarsk Standard Time - Krasnoyarsk',
    value: 'Asia/Krasnoyarsk',
    offset: 7
  },
  {
    label: 'Krasnoyarsk Standard Time - Novokuznetsk',
    value: 'Asia/Novokuznetsk',
    offset: 7
  },
  {
    label: 'Novosibirsk Standard Time',
    value: 'Asia/Novosibirsk',
    offset: 7
  },
  {
    label: 'Tomsk Time',
    value: 'Asia/Tomsk',
    offset: 7
  },
  {
    label: 'Western Indonesia Time - Jakarta',
    value: 'Asia/Jakarta',
    offset: 7
  },
  {
    label: 'Western Indonesia Time - Pontianak',
    value: 'Asia/Pontianak',
    offset: 7
  },
  {
    label: 'Australian Western Standard Time - Casey',
    value: 'Antarctica/Casey',
    offset: 8
  },
  {
    label: 'Australian Western Standard Time - Perth',
    value: 'Australia/Perth',
    offset: 8
  },
  {
    label: 'Brunei Darussalam Time',
    value: 'Asia/Brunei',
    offset: 8
  },
  {
    label: 'Central Indonesia Time',
    value: 'Asia/Makassar',
    offset: 8
  },
  {
    label: 'China Standard Time - Macau',
    value: 'Asia/Macau',
    offset: 8
  },
  {
    label: 'China Standard Time - Shanghai',
    value: 'Asia/Shanghai',
    offset: 8
  },
  {
    label: 'Choibalsan Standard Time',
    value: 'Asia/Choibalsan',
    offset: 8
  },
  {
    label: 'Hong Kong Standard Time',
    value: 'Asia/Hong_Kong',
    offset: 8
  },
  {
    label: 'Irkutsk Standard Time',
    value: 'Asia/Irkutsk',
    offset: 8
  },
  {
    label: 'Malaysia Time - Kuala Lumpur',
    value: 'Asia/Kuala_Lumpur',
    offset: 8
  },
  {
    label: 'Malaysia Time - Kuching',
    value: 'Asia/Kuching',
    offset: 8
  },
  {
    label: 'Philippine Standard Time',
    value: 'Asia/Manila',
    offset: 8
  },
  {
    label: 'Singapore Standard Time',
    value: 'Asia/Singapore',
    offset: 8
  },
  {
    label: 'Taipei Standard Time',
    value: 'Asia/Taipei',
    offset: 8
  },
  {
    label: 'Ulaanbaatar Standard Time',
    value: 'Asia/Ulaanbaatar',
    offset: 8
  },
  {
    label: 'Australian Central Western Standard Time',
    value: 'Australia/Eucla',
    offset: 8.75
  },
  {
    label: 'East Timor Time',
    value: 'Asia/Dili',
    offset: 9
  },
  {
    label: 'Eastern Indonesia Time',
    value: 'Asia/Jayapura',
    offset: 9
  },
  {
    label: 'Japan Standard Time',
    value: 'Asia/Tokyo',
    offset: 9
  },
  {
    label: 'Korean Standard Time - Pyongyang',
    value: 'Asia/Pyongyang',
    offset: 9
  },
  {
    label: 'Korean Standard Time - Seoul',
    value: 'Asia/Seoul',
    offset: 9
  },
  {
    label: 'Palau Time',
    value: 'Pacific/Palau',
    offset: 9
  },
  {
    label: 'Yakutsk Standard Time - Chita',
    value: 'Asia/Chita',
    offset: 9
  },
  {
    label: 'Yakutsk Standard Time - Khandyga',
    value: 'Asia/Khandyga',
    offset: 9
  },
  {
    label: 'Yakutsk Standard Time - Yakutsk',
    value: 'Asia/Yakutsk',
    offset: 9
  },
  {
    label: 'Australian Central Standard Time',
    value: 'Australia/Darwin',
    offset: 9.5
  },
  {
    label: 'Australian Eastern Standard Time - Brisbane',
    value: 'Australia/Brisbane',
    offset: 10
  },
  {
    label: 'Australian Eastern Standard Time - Lindeman',
    value: 'Australia/Lindeman',
    offset: 10
  },
  {
    label: 'Chamorro Standard Time',
    value: 'Pacific/Guam',
    offset: 10
  },
  {
    label: 'Chuuk Time',
    value: 'Pacific/Chuuk',
    offset: 10
  },
  {
    label: 'Dumont-d’Urville Time',
    value: 'Antarctica/DumontDUrville',
    offset: 10
  },
  {
    label: 'Papua New Guinea Time',
    value: 'Pacific/Port_Moresby',
    offset: 10
  },
  {
    label: 'Vladivostok Standard Time - Ust-Nera',
    value: 'Asia/Ust-Nera',
    offset: 10
  },
  {
    label: 'Vladivostok Standard Time - Vladivostok',
    value: 'Asia/Vladivostok',
    offset: 10
  },
  {
    label: 'Central Australia Time - Adelaide',
    value: 'Australia/Adelaide',
    offset: 10.5
  },
  {
    label: 'Central Australia Time - Broken Hill',
    value: 'Australia/Broken_Hill',
    offset: 10.5
  },
  {
    label: 'Bougainville Time',
    value: 'Pacific/Bougainville',
    offset: 11
  },
  {
    label: 'Eastern Australia Time - Currie',
    value: 'Australia/Currie',
    offset: 11
  },
  {
    label: 'Eastern Australia Time - Hobart',
    value: 'Australia/Hobart',
    offset: 11
  },
  {
    label: 'Eastern Australia Time - Melbourne',
    value: 'Australia/Melbourne',
    offset: 11
  },
  {
    label: 'Eastern Australia Time - Sydney',
    value: 'Australia/Sydney',
    offset: 11
  },
  {
    label: 'Kosrae Time',
    value: 'Pacific/Kosrae',
    offset: 11
  },
  {
    label: 'Lord Howe Time',
    value: 'Australia/Lord_Howe',
    offset: 11
  },
  {
    label: 'Macquarie Island Time',
    value: 'Antarctica/Macquarie',
    offset: 11
  },
  {
    label: 'Magadan Standard Time',
    value: 'Asia/Magadan',
    offset: 11
  },
  {
    label: 'New Caledonia Standard Time',
    value: 'Pacific/Noumea',
    offset: 11
  },
  {
    label: 'Norfolk Island Time',
    value: 'Pacific/Norfolk',
    offset: 11
  },
  {
    label: 'Ponape Time',
    value: 'Pacific/Pohnpei',
    offset: 11
  },
  {
    label: 'Sakhalin Standard Time',
    value: 'Asia/Sakhalin',
    offset: 11
  },
  {
    label: 'Solomon Islands Time',
    value: 'Pacific/Guadalcanal',
    offset: 11
  },
  {
    label: 'Srednekolymsk Time',
    value: 'Asia/Srednekolymsk',
    offset: 11
  },
  {
    label: 'Vanuatu Standard Time',
    value: 'Pacific/Efate',
    offset: 11
  },
  {
    label: 'Anadyr Standard Time',
    value: 'Asia/Anadyr',
    offset: 12
  },
  {
    label: 'Fiji Time',
    value: 'Pacific/Fiji',
    offset: 12
  },
  {
    label: 'Gilbert Islands Time',
    value: 'Pacific/Tarawa',
    offset: 12
  },
  {
    label: 'Marshall Islands Time - Kwajalein',
    value: 'Pacific/Kwajalein',
    offset: 12
  },
  {
    label: 'Marshall Islands Time - Majuro',
    value: 'Pacific/Majuro',
    offset: 12
  },
  {
    label: 'Nauru Time',
    value: 'Pacific/Nauru',
    offset: 12
  },
  {
    label: 'Petropavlovsk-Kamchatski Standard Time',
    value: 'Asia/Kamchatka',
    offset: 12
  },
  {
    label: 'Tuvalu Time',
    value: 'Pacific/Funafuti',
    offset: 12
  },
  {
    label: 'Wake Island Time',
    value: 'Pacific/Wake',
    offset: 12
  },
  {
    label: 'Wallis & Futuna Time',
    value: 'Pacific/Wallis',
    offset: 12
  },
  {
    label: 'New Zealand Time',
    value: 'Pacific/Auckland',
    offset: 13
  },
  {
    label: 'Phoenix Islands Time',
    value: 'Pacific/Enderbury',
    offset: 13
  },
  {
    label: 'Tokelau Time',
    value: 'Pacific/Fakaofo',
    offset: 13
  },
  {
    label: 'Tonga Standard Time',
    value: 'Pacific/Tongatapu',
    offset: 13
  },
  {
    label: 'Chatham Time',
    value: 'Pacific/Chatham',
    offset: 13.75
  },
  {
    label: 'Apia Time',
    value: 'Pacific/Apia',
    offset: 14
  },
  {
    label: 'Line Islands Time',
    value: 'Pacific/Kiritimati',
    offset: 14
  }
]
